module.exports = __webpack_public_path__ + "img/dhsxmzgh.40727647.png";